import api from "api";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { checkpoints } from "component/ChecklistMeter";
import _ from "lodash";
import "./../style.scss";
import { popinfo } from "component/Fancybox/Fancybox";
import { Link } from "react-router-dom";
import { calculateProjectTimeframe } from "page/Initiative/Inside/Scaffold";
import { MaterialSymbol } from "react-material-symbols";
import update from "immutability-helper";
import PaginationWrapper from "component/Pagination";

export default connect(stateMap)((props) => {
    const [isLoading, setIsLoading]     = useState(true);
    const [parameter, setParameter]     = useState(_.assignIn({}, props.args, {
        posts_per_page: 10,
        paged: 1
    }));
    const [initiatives, setInitiatives] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const mergedOrigCheckpoints = _.merge({}, checkpoints.event, checkpoints.research, checkpoints.research, checkpoints.default);
    const defaultKeys           = _.keys(checkpoints.default);
    const usedCheckpoints       = _.union(
        defaultKeys
        ,_.difference(
            _.intersection(
                _.keys(checkpoints.event)
            )
            ,defaultKeys
        )
    );

    useEffect(() => {
        setParameter(update(parameter, { $merge: props.args }));
    }, [props.args])

    useEffect(() => {
        setIsLoading(true);

        Promise.all(
            [
                api('/Monitor/GetListInitiativeStatus', 'get', parameter, 'Bearer ' + props.auth.token)
                ,api('/Monitor/GetListInitiativeStatus', 'get', {...parameter, get_total : 1}, 'Bearer ' + props.auth.token)
            ]
        ).then(([ResponseResult, ResponseTotal]) => {
            setIsLoading(false);
            setInitiatives(ResponseResult.initiatives);
            setTotalItems(parseInt(ResponseTotal.initiatives));
        })
        .catch(() => {
            setIsLoading(false);
            setInitiatives([]);
            setTotalItems(0);
        })

    }, [parameter]);

    const PromoteDemoteCoCreator = (initiative, status) => {
        console.log(initiative, props.auth);

        var PopMessage = popinfo('loading', 'Changing User Status', 'Please Wait');
                            
        api('/Role/Promote', 'post', {
            user_id : props.auth.user.UserID
            ,initiative_id : initiative.InitiativeID
            ,status  : status
        }, 'Bearer ' + props.auth.token)
            .then(() => {
                popinfo('ok', 'Changing Status Complete' , 'Please Refresh the initiative page', {}, PopMessage);
            })
            .catch((error) => {
                popinfo('error', 'Changing User Status' , error, {}, PopMessage);
            })
    }

    const GenerateDefaultRole = (initiative) => {
        
        var PopMessage = popinfo('loading', 'Generating Default ROle', 'Please Wait');
                            
        api('/Initiative/GenerateDefaultRole', 'post', {
            initiative_id : initiative.InitiativeID
        }, 'Bearer ' + props.auth.token)
            .then(() => {
                popinfo('ok', 'Role Generated' , 'Please Refresh the initiative page', {}, PopMessage);
            })
            .catch((error) => {
                popinfo('error', 'Role Generated Error' , error, {}, PopMessage);
            })
    }

    return (
        <div className="component-list-initiative-status component-list-monitoring">
            <div className="flex flex-wrap mb-sm">
                <div style={{
                    lineHeight :'38px'
                }}>
                    Filter initiative by :&nbsp;
                </div>
                <button className={`btn btn-mini btn-primary ${parameter.type === 'research' ? 'btn-reverse' : ''}`} onClick={e => {
                    setParameter({
                        ...parameter,
                        type: parameter.type === 'research' ? '' : 'research',
                        paged: 1
                    })
                }}><MaterialSymbol icon="experiment"/> Research</button>&nbsp;
                <button className={`btn btn-mini btn-primary ${parameter.type === 'event' ? 'btn-reverse' : ''}`} onClick={e => {
                    setParameter({
                        ...parameter,
                        type: parameter.type === 'event' ? '' : 'event',
                        paged: 1
                    })
                }}><MaterialSymbol icon="calendar_month"/> Event</button>&nbsp;
                <button className={`btn btn-mini btn-primary ${parameter.type === 'talent' ? 'btn-reverse' : ''}`} onClick={e => {
                    setParameter({
                        ...parameter,
                        type: parameter.type === 'talent' ? '' : 'talent',
                        paged: 1
                    })
                }}><MaterialSymbol icon="person_play"/> Talent Team</button>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Created Date</th>
                        <th>TimeFrame</th>
                        <th>Current <br/> Status</th>
                        <th>Total <br/> Participant</th>
                        <th>Checklist <br/> Meter</th>
                        {
                            usedCheckpoints.map((checkpoint) => (
                                <th className="checklist" key={checkpoint}>{mergedOrigCheckpoints[checkpoint].name}</th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        isLoading && 
                        <tr>
                            <td colSpan={21}>
                                <span className="skeleton"></span>
                            </td>
                        </tr>
                    }
                    {
                        !isLoading && initiatives.map((initiative) => (
                            <tr key={initiative.InitiativeID}>
                                <td>
                                    <Link to={`/initiative/${initiative.Slug}`} target="_blank">
                                        {initiative.Title}
                                    </Link>
                                    <br/>
                                    {
                                        initiative.Membership.membership !== null && initiative.InitiatorID !== props.auth.user.UserID &&
                                        <>
                                            {
                                                initiative.Membership.membership.MemberType === 'contributor' ? 
                                                <button className="text-xs mt-sm color-brand" onClick={(e) => {PromoteDemoteCoCreator(initiative, 'promote')}}>Promote me as co-creator</button> : 
                                                <button className="text-xs mt-sm color-brand"  onClick={(e) => {PromoteDemoteCoCreator(initiative, 'demote')}}>Demote me as co-creator</button>
                                            }
                                        </>
                                    }
                                    <br/>
                                    {
                                        !initiative.Checklist.includes('setup-role') && (
                                            (() => (
                                                <button className="text-xs mt-sm color-brand"  onClick={(e) => {GenerateDefaultRole(initiative)}}>Generate Default Role</button>
                                            ))()
                                        )
                                    }
                                </td>
                                <td>{initiative.InitiativeTypeTitle}</td>
                                <td>{initiative.CreatedDate}</td>
                                <td>{calculateProjectTimeframe(initiative)}</td>
                                <td>{initiative.CurrentStatusTitle}</td>
                                <td style={{textAlign : 'center'}} >{initiative.TotalJoined}</td>
                                <td className="checklist-meter">
                                    <span className="bar-indicator" style={{
                                        width : `${ Math.min(100, Math.round(_.intersection(initiative.Checklist, usedCheckpoints).length / usedCheckpoints.length * 100)) }%`
                                    }}></span>
                                    {
                                        Math.min(100, Math.round(_.intersection(initiative.Checklist, usedCheckpoints).length / usedCheckpoints.length * 100)) 
                                    }%
                                </td>
                                {
                                    usedCheckpoints.map((checkpoint) => (
                                        <td  className="checklist" key={checkpoint}>{_.indexOf(initiative.Checklist, checkpoint) >= 0 ? 'Y' : ''}</td>
                                    ))
                                }
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            {!isLoading && totalItems > parameter.posts_per_page && (
                <PaginationWrapper
                    className="mt-4"
                    activePage={parameter.paged}
                    itemsCountPerPage={parameter.posts_per_page}
                    totalItemsCount={totalItems}
                    pageRangeDisplayed={5}
                    onChange={(pagenumber) => {
                        setParameter(update(parameter, { paged: {$set: pagenumber} }))
                    }}
                />
            )}
        </div>
    )
});